import { formatDate } from '@angular/common';
const defaultDateLocale = 'en';

/**
 * Get's the locale id from the navigator object and tests Angular's date function to ensures it's supported
 * Provide a default in a situation the locale is not usable - prevent JS from halting
 * @returns a string of the locale id e.g. 'nl' or 'en-US'
 */
export function loadLocaleId(): string {
  const localeId = navigator.language;
  try {
    formatDate(new Date(), 'yyyy-mm-dd', localeId);
  } catch {
    console.warn(`Locale ${localeId} is not imported`);
    return defaultDateLocale;
  }

  return localeId;
}
